import React, { useEffect, useState } from 'react';
import { SettingsState } from '../../../organisms/SelectSettings';
import Grid from '@material-ui/core/Grid';

import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';
import { useModal } from '../../../../function/useModal';
import { ResponceDataType, ErrorCode } from '../../../../ErrorCode';
import { useTranslation } from 'react-i18next';
import StudySettingFooter from './StudySettingFooter';
import StudySetting1Grid from './StudySetting1Grid';
import {
  StudySettingModel,
  CreateStudySettingModel,
  GetStudySetting,
  STUDY_SET_1,
  STUDY_SET_2,
  CheckStudySettingEditFlg,
  PutStudySetting,
  CheckStudySettingInputData,
} from './StudySetting';
import StudySetting2EditBody from './StudySetting2EditBody';

type StudySettingPageProps = { editData: SettingsState };

/**
 *学習設定画面
 * @returns
 */
const StudySettingPage: React.FC<StudySettingPageProps> = (props) => {
  const [studySettingModel, setStudySettingModel] = useState<StudySettingModel>(CreateStudySettingModel());

  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();

  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const { t, i18n } = useTranslation();
  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('StudySettingPage.はい', 'はい')}
      cancel={t('StudySettingPage.いいえ', 'いいえ')}
    />
  ) : null;

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  useEffect(() => {
    props.editData.SaveFunction = saveAction2;
    props.editData.IsUpdate = false;
  }, [props.editData.CancelCondition]);
  /**
   * 初期表示　useEffect
   */
  useEffect(() => {
    upDatePage();
    //GetStudySettingEx().then((r) => {});
  }, []);

  /**
   * 画面更新
   */
  const upDatePage = () => {
    setButtonEnable(false);
    let stdModel: StudySettingModel = CreateStudySettingModel();
    GetStudySetting()
      .then((r: StudySettingModel) => {
        console.debug(['StudySettingPage - upDatePage - GetStudySetting', r]);
        stdModel = r;
        setStudySettingModel(r);
      })
      .catch((e) => {
        setDlgmsg(t('StudySettingPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['upDatePage - Error', e]);
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  /**
   *保存ボタン
   * @param index
   */
  const saveAction = () => {
    if (CheckStudySettingEditFlg(studySettingModel)) {
      //inputチェック
      const messages = CheckStudySettingInputData(studySettingModel.StudySet1List, t);
      if (messages.length != 0) {
        setDlgmsg(messages.join('\n'));
        actMsgDlg.open();
        return;
      }

      setDlgmsg(
        t('StudySettingPage.編集内容を保存します。\nよろしいですか?', '編集内容を保存します。\nよろしいですか?')
      );
      actCfmDlg
        .open()
        .apply((_) => {
          setButtonEnable(false);
          PutStudySetting(studySettingModel)
            .then((r) => {
              setDlgmsg(t('StudySettingPage.保存が正常に終了しました', '保存が正常に終了しました'));
              actMsgDlg.open();
              props.editData.IsUpdate = false;
              upDatePage(); //再描画
              console.debug('saveAction ok');
            })
            .catch((r) => {
              setDlgmsg(t('StudySettingPage.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
              actMsgDlg.open();
              console.error(['saveAction error', r]);
            })
            .finally(() => {
              setButtonEnable(true);
            });
        })
        .cancel(() => {
          console.debug(t('StudySettingPage.キャンセル', 'キャンセル'));
        });
    } else {
    }
  };

  /**
   * タブ切替時に動作
   * @param param
   * @returns
   */
  const saveAction2 = (param: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const sp = param as StudySettingModel;
      console.debug(['★saveAction2', param]);
      setButtonEnable(false);
      PutStudySetting(sp)
        .then((r) => {
          props.editData.IsUpdate = false;
          console.debug('saveAction ok');
          resolve('done');
        })
        .catch((r) => {
          setDlgmsg(t('StudySettingPage.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
          actMsgDlg.open();
          console.error(['saveAction error', r]);
          reject('data error');
        })
        .finally(() => {
          setButtonEnable(true);
        });
    });
  };

  /**
   *キャンセルボタン押下
   */
  const cancelAction = () => {
    console.debug(['cancelAction', studySettingModel]);
    if (CheckStudySettingEditFlg(studySettingModel)) {
      setDlgmsg(
        t(
          'StudySettingPage.保存していないデータを破棄します。\nよろしいですか?',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          upDatePage(); //再描画
          props.editData.IsUpdate = false;
          console.debug(t('StudySettingPage.実行', '実行'));
        })
        .cancel(() => {
          console.debug(t('StudySettingPage.キャンセル', 'キャンセル'));
        });
    } else {
    }
  };

  /**
   *学習設定(乗数設定)データ変更通知
   * @returns
   */
  const changeActionStudySetting1 = (target: STUDY_SET_1) => {
    console.debug(['changeActionStudySetting1 - start', studySettingModel, target]);
    target.isEdit = true;
    var index = studySettingModel.StudySet1List.findIndex((r) => r.indexNo === target.indexNo);
    studySettingModel.StudySet1List[index] = target;
    props.editData.Target = studySettingModel;
    props.editData.IsUpdate = true;
    //setPLMSettingList([...plmSettingList]);
    console.debug(['changeActionStudySetting1 - end', studySettingModel, target]);
  };

  /**
   *学習設定(ばらつき係数)データ変更通知
   * @returns
   */
  const changeActionStudySetting2 = (target: STUDY_SET_2) => {
    console.debug(['changeActionStudySetting2 - start', studySettingModel, target]);
    target.isEdit = true;
    var index = studySettingModel.StudySet2List.findIndex((r) => r.indexNo === target.indexNo);
    studySettingModel.StudySet2List[index] = target;
    props.editData.Target = studySettingModel;
    props.editData.IsUpdate = true;
    //setPLMSettingList([...plmSettingList]);
    console.debug(['changeActionStudySetting2 - end', studySettingModel, target]);
  };

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 5 }}>
        <Grid item xs={12}>
          <StudySetting2EditBody
            studySet2List={studySettingModel.StudySet2List}
            onChangeData={changeActionStudySetting2}
          ></StudySetting2EditBody>
        </Grid>
        <Grid item xs={12}>
          <StudySetting1Grid
            studySet1List={studySettingModel.StudySet1List}
            onChangeData={changeActionStudySetting1}
          ></StudySetting1Grid>
        </Grid>{' '}
        <Grid item xs={12}>
          <StudySettingFooter
            onClickSaveButton={saveAction}
            onClickCancelButton={cancelAction}
            buttonEnable={buttonEnable}
          ></StudySettingFooter>
        </Grid>
        {cfmdlg}
        {msgdlg}
      </Grid>
    </>
  );
};

export default StudySettingPage;
